<template>
    <div>
        <div v-if="loading">
            <Loading />
        </div>
        <div v-else>
            <div v-if="error">
                <p class="has-text-weight-bold">{{ error }}</p>
            </div>
            <div v-else>
                <SurveyViewer v-if="survey" :survey="survey" />
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import SurveyViewer from "./SurveyViewer.vue";
import Loading from "@/components/Loading.vue";

export default {
    name: "survey-loader",
    components: { Loading, SurveyViewer },
    props: {
        surveyId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            survey: null,
            error: null,
            loading: false,
        };
    },
    async mounted() {
        await this.retrieveSurvey();
    },
    methods: {
        async retrieveSurvey() {
            try {
                this.error = null;
                this.loading = true;
                let response = await RepositoryFactory.integration.GetSurvey({
                    surveyId: this.surveyId,
                });
                this.survey = response.data;
            } catch (error) {
                window.console.log(error);
                if (error.response.status === 404) {
                    this.error = this.$t("survey-viewer.not-found");
                } else {
                    this.error = this.$t("survey-viewer.error");
                }
            }
            this.loading = false;
        },
    },
};
</script>